import { Stack } from '@mui/material';
import { DetailResponse, ResParticipant } from 'features/lead/lead-management/lead-questionnaire-details/lead-questionnaire-details.types';
import PaiButton from 'features/ui/base-components/pai-button';
import _ from 'lodash';
import React from 'react';
import { makeStyles } from 'tss-react/mui';
import ParticipantCreationItem from './participant-creation-item';
import ParticipantItem from './participant-item';

interface Props {
  details?: DetailResponse;
  participantsToAdd?: Array<{ name: string; perspective: string }>;
  isCreationView?: boolean;

  handleOpenAddParticipantsDialog(): void;

  copyToClipboard?(participant: ResParticipant): () => void;

  copyToClipboardAnonymous?(): void;

  getRealPerspective(id: string): string;

  handleEditParticipantIsSuspended?(id: string): (event: React.ChangeEvent<HTMLInputElement>) => void;

  handleEditParticipantRole?(id: string): (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const ParticipantList: React.FC<Props> = ({
  details,
  participantsToAdd,
  isCreationView,
  handleOpenAddParticipantsDialog,
  copyToClipboard,
  copyToClipboardAnonymous,
  getRealPerspective,
  handleEditParticipantIsSuspended,
  handleEditParticipantRole,
}) => {
  const { classes } = useStyles();

  return (
    <Stack className={classes.leadParticipantsContent} gap={2}>
      <Stack className={classes.actions} direction={'row'} gap={2} justifyContent={'space-between'}>
        <PaiButton text={'Anonymer Link'} fullWidth={true} size={'small'} action={copyToClipboardAnonymous} disabled={isCreationView} />
        <PaiButton text={'+ Feedbackgeber'} fullWidth={true} size={'small'} action={handleOpenAddParticipantsDialog} />
      </Stack>
      <Stack className={classes.participants}>
        {!_.isNil(details) && !_.isNil(copyToClipboard) && !_.isNil(handleEditParticipantIsSuspended) && !_.isNil(handleEditParticipantRole)
          ? details.participants.map((participant, index) => (
              <ParticipantItem
                key={participant.id}
                participant={participant}
                isEven={index % 2 === 0}
                copyToClipboard={copyToClipboard}
                getRealPerspective={getRealPerspective}
                handleEditParticipantIsSuspended={handleEditParticipantIsSuspended}
                handleEditParticipantRole={handleEditParticipantRole}
              />
            ))
          : null}
        {!_.isNil(participantsToAdd)
          ? participantsToAdd.map((participant, index) => (
              <ParticipantCreationItem key={index} participant={participant} isEven={index % 2 === 0} getRealPerspective={getRealPerspective} />
            ))
          : null}
      </Stack>
    </Stack>
  );
};

const useStyles = makeStyles()((theme) => ({
  leadParticipantsContent: {
    height: 'calc(100% - 19.5px - 32px)',
  },
  actions: {
    padding: '16px',
    border: `2px solid ${theme.palette.backgrounds.main}`,
  },
  participants: {
    maxHeight: 'calc(100% - 16px - 65px)',
    border: `2px solid ${theme.palette.backgrounds.main}`,
    overflow: 'auto',
  },
}));

export default ParticipantList;
